<template>
  <div>
    
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <v-autocomplete
                    label="Select Staff"
                    item-text="staff_name"
                    item-value="id"
                    :items="outsourceStaff"
                    v-model="formSchema.user_id"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                    clearable                   
                  ></v-autocomplete>
                </v-flex>
                
                <v-flex xs12 sm4 md4>                
                <v-autocomplete
                    label="Leave Type"
                    item-text="name"
                    item-value="id"
                    :items="leaveType"
                    v-model="formSchema.leave_type"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                  ></v-autocomplete>
                </v-flex>

                 <v-flex xs12 sm4 md4>
                   <v-text-field
                    label="Purpose of Leave"
                    v-model="formSchema.leave_purpose"
                    :rules="[(v) => !!v || 'Field is required']"
                    required                   
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm8 md8>
                  <div style="
                  border: 1px solid #CCC;
                  position: relative;
                  padding-top: 14px;
                  margin-top:5px;
                  ">
                  <div style="
                  position: absolute;
                  top: -13px;
                  overflow: hidden;
                  left: 10px;
                  background: #FFF;
                  font-size: 16px;
                  color: rgba(0, 0, 0, 0.54);
                  ">Duration <span v-if="totalDays > 0 " :style="{ color: 'red'}">{{totalDays}}(days)</span></div>

                  <v-layout wrap>
                    <v-flex xs6>                    
                      <DatePicker
                      :key="formSchema.id"
                      :inputData="{
                      index: 1,
                      fieldName: 'from_date',
                      fieldValue: formSchema.from_date,
                      label: 'Start Date'
                    }"
                    @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs6>                   
                    <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                    index: 3,
                    fieldName: 'to_date',
                    fieldValue: formSchema.to_date,
                    label: 'End Date',
                    disabled:'1'
                    }"
                    @setValue="setDateValue"
                    ref="setRange"
                    ></DatePicker>                    
                  </v-flex>
                </v-layout>
              </div>
              </v-flex>

                <!-- <v-flex xs12 sm4 md4>
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 1,
                      fieldName: 'from_date',
                      fieldValue: formSchema.from_date,
                      label: 'Start Date'
                    }"
                    @setValue="setDateValue"
                  ></DatePicker>
                </v-flex>
               
                <v-flex xs12 sm4 md4>
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 3,
                      fieldName: 'to_date',
                      fieldValue: formSchema.to_date,
                      label: 'End Date',
                      disabled:'1'
                    }"
                    @setValue="setDateValue"
                    ref="setRange"
                  ></DatePicker>
                </v-flex> -->

                <v-flex xs12 sm6 md4>	
				<v-checkbox v-model="formSchema.is_station_leave" label="with station leave" :value="isActiveVal"></v-checkbox>
				</v-flex>
                <v-flex xs12 sm6 md6>
                <v-textarea
                    label="Leave Address"
                    v-model="formSchema.leave_contact_address"
                    :rules="[v => !!v || 'Leave Address is required !']"
                    required
                 ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.native="validateBeforeSubmit">{{
              btnTitle
            }}</v-btn>
            <v-btn color="error" @click.native="reset">Reset</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");

import { preFix } from "../../../vuex/api";
import DatePicker from "../../global/date_picker";
import Axios from "axios";
export default {
 components: {
    DatePicker
  },
  props: ["formSchema"],
  data: () => ({
    valid: true,
    dialog: false,
    dialogEditForm: false,
    isActiveVal: 0,
    search: "",
    totalItems: 0,
    loading: true,
    eco_code:[],
    pagination: {
      sortBy: "id",
      descending: true,
    },
    selected: [],
    search: "",
    

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    outsourceStaff:[],
    // leaveType:[
    //   {id:1, name:"Casual Leave"},
    //   {id:2, name:"Medical Leave"},
    //   {id:3, name:"Quarantine Leave"},
    //   {id:4, name:"Ordinary Leave"},
    // ],
    totalDays: ''

   
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Leave Entry"
        : "Add New Leave Entry";
    },
    btnTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
   
  },
  watch:{
     "formSchema.to_date" (){
       this.setDays()
     }
  },

  created() {
    commonService.getAllData("dropdown-data")
    .then(res => {
        this.outsourceStaff = res.outsource_staffs
    })
    .catch(err => {

    });

    this.getLeaveType();
  },

  methods: {

    getLeaveType(){  
        commonService.getAllData('get_leave_type').then(res => {                                    
          this.leaveType = res.leave_type;
        });
      },

    setDateValue(data) {
     let index = data.index;
      this.formSchema[data.fieldName] = data.value;
      if(data.fieldName == "from_date"){
        this.formSchema.to_date = 0
        this.totalDays = ''
        this.$refs.setRange.setRange(data.value);
      }
        this.setDays()
    },
    setDays() {
      if(!this.formSchema.from_date == '' && !this.formSchema.to_date == '') {
      let fromdatearray = this.formSchema.from_date.split("/");
      let todatearray = this.formSchema.to_date.split("/");
      let newfromdate = fromdatearray[1] + '/' + fromdatearray[0] + '/' + fromdatearray[2];
      let newtodate = todatearray[1] + '/' + todatearray[0] + '/' + todatearray[2];

      //calculate days
      let date1 = new Date(newfromdate); 
      let date2 = new Date(newtodate); 
      let Difference_In_Time = date2.getTime() - date1.getTime();
      let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      
      this.totalDays = Difference_In_Days + 1
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;
      formSchema.from_date = formSchema.from_date == '' ? '' :root.changeFormateYMD(
        formSchema.from_date
        );
    
      formSchema.to_date = formSchema.to_date == 0 ? '' :root.changeFormateYMD(
        formSchema.to_date
        );
      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(formSchema, "leave-management")
            .then((res) => {
             
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(formSchema, "leave-management")
            .then((res) => {
              console.log(res)
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
              };
              this.close(actionData);
            });
        }
      }
    },

    close: function(message) {
      if (message.status == 1) {
         this.formSchema.from_date = ''
         this.formSchema.to_date = ''
        this.$refs.form.reset();
      }
      this.$emit("reloadData", message);
    },
     reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
  },

};
</script>

<style>
  .duration{    
    position: absolute;
    top: -10px;
    overflow: hidden;
    padding: 0 2px;
    background: #FFF;
    font-size: 15px;
    color: rgba(0,0,0,0.54);
  }
</style>


// WEBPACK FOOTER //
// src/components/administration/leave_entry/leave_form.vue